/* AnnMichell 2026 collection page — behaviour for sections/am-col-main.liquid.
   Filters / sort / clear: rebuild the URL from Shopify's own params and swap the section via the
   Section Rendering API (?section_id=), keeping the URL shareable (pushState). Show more: fetch the
   next page's section and append its cards. Any fetch failure falls back to a normal page load. */
(function () {
  if (window.__am26c) return;
  window.__am26c = true;

  var WISH_KEY = 'items'; // same localStorage key the theme wishlist page (/pages/wishlist) reads
  var busy = null;

  function root() { return document.querySelector('[data-am26c]'); }
  function sid() { var r = root(); return r && r.getAttribute('data-section-id'); }

  function keepPreview(u) {
    var cur = new URL(location.href);
    var pv = cur.searchParams.get('preview_theme_id');
    if (pv && !u.searchParams.get('preview_theme_id')) u.searchParams.set('preview_theme_id', pv);
    return u;
  }

  function formUrl() {
    var r = root(); var form = r && r.querySelector('[data-am26c-form]');
    var u = new URL(form ? form.getAttribute('action') : location.pathname, location.origin);
    if (form) {
      var fd = new FormData(form);
      fd.forEach(function (v, k) { if (String(v).trim() !== '') u.searchParams.append(k, v); });
    }
    return keepPreview(u);
  }

  function lockScroll(on) { document.documentElement.classList.toggle('am26c-lock', !!on); }

  function openSheet() { var r = root(); if (!r) return; r.classList.add('is-sheet-open'); lockScroll(true); }
  function closeSheet() { var r = root(); if (!r) return; r.classList.remove('is-sheet-open'); lockScroll(false); }

  function go(href, opts) {
    opts = opts || {};
    var r = root(); var id = sid();
    var u = keepPreview(new URL(href, location.origin));
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    if (!r || !id || !window.fetch || !window.DOMParser) { location.href = u.toString(); return; }
    var f = new URL(u.toString()); f.searchParams.set('section_id', id);
    if (busy) busy.abort && busy.abort();
    var ctrl = window.AbortController ? new AbortController() : null; busy = ctrl;
    r.classList.add('is-loading');
    fetch(f.toString(), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-am26c]');
        if (!fresh) throw new Error('no section');
        var cur = root();
        var wasOpen = cur.classList.contains('is-sheet-open');
        var body = cur.querySelector('[data-am26c-sheet-body]');
        var scrollTop = body ? body.scrollTop : 0;
        var openGroups = {};
        cur.querySelectorAll('.am26c-grp').forEach(function (d, i) { openGroups[i] = d.open; });
        cur.replaceWith(fresh);
        // keep groups the shopper opened/closed by hand
        fresh.querySelectorAll('.am26c-grp').forEach(function (d, i) { if (i in openGroups && openGroups[i] && !d.open) d.open = true; });
        if (wasOpen) {
          fresh.classList.add('is-sheet-open');
          var nb = fresh.querySelector('[data-am26c-sheet-body]'); if (nb) nb.scrollTop = scrollTop;
        }
        if (opts.push !== false) history.pushState({ am26c: 1 }, '', u.pathname + u.search);
        markHearts();
        if (opts.scrollTop) {
          var g = fresh.querySelector('.am26c-body');
          if (g) window.scrollTo({ top: g.getBoundingClientRect().top + window.pageYOffset - 10, behavior: 'smooth' });
        }
        document.dispatchEvent(new CustomEvent('am26c:updated', { detail: { url: u.toString() } }));
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; location.href = u.toString(); });
  }

  function more(btn) {
    var wrap = btn.closest('[data-am26c-more]'); var id = sid(); var r = root();
    // phones: the first Show more reveals the rest of the current page (cards past per_page_mobile), no fetch
    var g = r && r.querySelector('[data-am26c-grid]');
    if (g && !g.classList.contains('is-all') && window.matchMedia('(max-width: 989px)').matches) {
      var firstHidden = null, kids = g.children;
      for (var i = 0; i < kids.length; i++) { if (getComputedStyle(kids[i]).display === 'none') { firstHidden = kids[i]; break; } }
      g.classList.add('is-all');
      if (firstHidden) { var fa = firstHidden.querySelector('a'); if (fa) fa.focus({ preventScroll: true }); }
      return;
    }
    if (btn.getAttribute('href') === '#') return;
    var href = btn.getAttribute('href');
    if (!id || !window.fetch || !window.DOMParser) { location.href = href; return; }
    var f = new URL(href, location.origin); f.searchParams.set('section_id', id);
    wrap.classList.add('is-loading'); btn.textContent = 'Loading…';
    fetch(f.toString(), { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = r.querySelector('[data-am26c-grid]');
        var newGrid = doc.querySelector('[data-am26c-grid]');
        var newMore = doc.querySelector('[data-am26c-more]');
        if (!grid || !newGrid || !newMore) throw new Error('bad page');
        var first = null;
        Array.prototype.slice.call(newGrid.children).forEach(function (c) { if (!first) first = c; grid.appendChild(c); });
        wrap.replaceWith(newMore);
        markHearts();
        if (first) { var a = first.querySelector('a'); if (a) a.focus({ preventScroll: true }); }
      })
      .catch(function () { location.href = href; });
  }

  /* ---------- wishlist hearts (theme key "items" = array of handles) ---------- */
  function wishList() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]') || []; } catch (e) { return []; } }
  function markHearts() {
    var list = wishList();
    document.querySelectorAll('[data-am26c-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function toggleWish(b) {
    var h = b.getAttribute('data-handle'); var list = wishList(); var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
    markHearts();
  }

  /* ---------- events (delegated: the section is replaced on every filter change) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('[data-am26c]')) return;
    var el;
    if ((el = t.closest('[data-am26c-wish]'))) { e.preventDefault(); toggleWish(el); return; }
    if ((el = t.closest('[data-am26c-open]'))) { e.preventDefault(); openSheet(); return; }
    if ((el = t.closest('[data-am26c-next]'))) { e.preventDefault(); more(el); return; }
    if ((el = t.closest('[data-am26c-desc-toggle]'))) {
      var dsc = el.closest('[data-am26c-desc]'), open = !dsc.classList.contains('is-open');
      dsc.classList.toggle('is-open', open); el.setAttribute('aria-expanded', open ? 'true' : 'false'); el.textContent = open ? 'Read less' : 'Read more';
      return;
    }
    // "Find my size": the size quiz when it is on the page (snippets/find-my-size), else the link (/pages/sizing-chart)
    if ((el = t.closest('[data-am26c-fms]')) && window.AMFMS && typeof window.AMFMS.open === 'function' && document.getElementById('am-fms-overlay')) {
      e.preventDefault(); window.AMFMS.open(); return;
    }
    if ((el = t.closest('[data-am26c-go]'))) {
      if (el.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (el.hasAttribute('data-am26c-rm')) {
        var name = el.getAttribute('data-am26c-rm');
        var vals = (el.getAttribute('data-vals') || '').split('|||').filter(Boolean);
        var u = new URL(location.href);
        var keep = u.searchParams.getAll(name).filter(function (v) { return vals.indexOf(v) < 0; });
        u.searchParams.delete(name); keep.forEach(function (v) { u.searchParams.append(name, v); });
        go(u.toString()); return;
      }
      go(el.getAttribute('href')); return;
    }
    if ((el = t.closest('[data-am26c-allcolors]'))) {
      e.preventDefault(); var cs = el.parentNode.querySelector('.am26c-colors');
      if (cs) { var on = cs.classList.toggle('show-all'); el.textContent = on ? 'Show fewer colors' : el.getAttribute('data-label'); }
      return;
    }
    if ((el = t.closest('[data-am26c-apply]'))) { e.preventDefault(); go(formUrl().toString()); return; }
    if ((el = t.closest('[data-am26c-close]'))) {
      e.preventDefault(); closeSheet();
      if (el.hasAttribute('data-am26c-show')) {
        var g = root() && root().querySelector('.am26c-body');
        if (g) window.scrollTo({ top: g.getBoundingClientRect().top + window.pageYOffset - 60, behavior: 'smooth' });
      }
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target; if (!t.closest || !t.closest('[data-am26c]')) return;
    if (t.matches('[data-am26c-sort]')) {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', t.value); u.searchParams.delete('page');
      var r = root(); var sf = r && r.querySelector('[data-am26c-sortfield]'); if (sf) sf.value = t.value;
      go(u.toString());
      return;
    }
    if (t.closest('[data-am26c-form]')) {
      // one colour swatch can hold several spellings ("Beige"/"beige"): keep them in step
      var lab = t.closest('.am26c-color, .am26c-size');
      if (lab) lab.querySelectorAll('input[type=checkbox]').forEach(function (i) { i.checked = t.checked; });
      if (t.type === 'number') return; // price waits for Apply / Enter
      go(formUrl().toString());
    }
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t.closest && t.closest('[data-am26c-form]') && t.type === 'number') { e.preventDefault(); go(formUrl().toString()); }
    if (e.key === 'Escape') { var r = root(); if (r && r.classList.contains('is-sheet-open')) closeSheet(); }
  });

  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('[data-am26c-form]')) { e.preventDefault(); go(formUrl().toString()); }
  });

  window.addEventListener('popstate', function () { if (root()) go(location.href, { push: false }); });

  // layout/theme.liquid sets a global window.onpopstate for the search page's #search-filters-form: on Back it
  // pushes "<path>?" (empty form) and re-fetches the whole page, which breaks Back on this collection page.
  // Only here (our section present, no search form) ignore that assignment; our listener above handles Back.
  if (root() && !document.getElementById('search-filters-form')) {
    try { Object.defineProperty(window, 'onpopstate', { configurable: true, get: function () { return null; }, set: function () {} }); } catch (e) {}
  }

  function labelButtons() { document.querySelectorAll('[data-am26c-allcolors]').forEach(function (b) { if (!b.getAttribute('data-label')) b.setAttribute('data-label', b.textContent); }); }
  document.addEventListener('am26c:updated', labelButtons);
  function init() { markHearts(); labelButtons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
